/*
    Unknown.unknownString is used in Solution.js: 
    If a temperature is given (dataIn.temperature), it checks for an unknown...
    
    If a species list is given [{id: 0}, {id: 10, amount: moles_of_10}], it
    parses these and substitutes the appropriate part of the unknownString...

    Species checks for unknown strings in entropy, cp, enthalpy, specific heat...

 */
/* 
    What should this interface look like?
    For backward compatibility, take an unknown string, and parse it into
    an object this.unknowns = {u1: 203.2, u2: 273};

    If window.parent.thisProblem contains an unknowns object, just copy that
    over:
    this.unknowns = window.parent.thisProblem.unknowns

*/

/* This works. The nex thing that needs to be added is a layer injecting
 * the unknowns directly when the problem is loaded.
 */
function Unknown() {
    let unknownString = "";
    let unknowns = {};
    try {
    if (window.parent.thisProblem) {
        unknownString = window.parent.thisProblem.unknownString;
        if (window.parent.thisProblem.unknowns) {
            unknowns = window.parent.thisProblem.unknowns;
        } else if (unknownString) {
            let unknownArray = unknownString.split(',');
            for (let i = 0; i <unknownArray.length; i = i + 2) {
                unknowns[unknownArray[i]] = parseFloat(unknownArray[i+1]);
            }
        }
    }
    } catch (e) {
        console.log("Not loading any potential unknowns...")
    }
    return {unknownString, unknowns};
}

module.exports = Unknown;